import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";
import { useReveal } from "../../lib/animations";

const items = [
  {
    q: "Hoe nauwkeurig is de analyse?",
    a: "Onze AI is getraind op duizenden Belgische en Nederlandse markttarieven en wordt continu bijgewerkt. De analyse geeft een betrouwbare indicatie, maar blijft een advies — bij twijfel raden we aan een tweede offerte op te vragen.",
  },
  {
    q: "Welke soorten offertes kan ik uploaden?",
    a: "Renovatie, elektriciteit, schilderwerk, tuinaanleg, IT, verhuizing, onderhoud en meer. Heb je een ander type? Kies dan 'Andere' in de wizard en we passen de analyse aan.",
  },
  {
    q: "Wat gebeurt er met mijn gegevens?",
    a: "Documenten en analyseresultaten worden 30 dagen bewaard en daarna automatisch en permanent verwijderd. We delen nooit gegevens met derden behalve onze technische dienstverleners (analyse en betaalproviders).",
  },
];

export default function FaqPreview() {
  const ref = useReveal();
  return (
    <section data-testid="faq-preview" className="oc-section bg-white">
      <div ref={ref} className="oc-reveal oc-container max-w-3xl">
        <div className="max-w-3xl">
          <span className="text-[13px] uppercase tracking-[0.1em] font-semibold text-oc-secondary">
            Veelgesteld
          </span>
          <h2 className="font-display font-bold text-[28px] sm:text-[36px] lg:text-[42px] leading-tight tracking-tight text-oc-primary mt-3 whitespace-normal lg:whitespace-nowrap">
            Vragen die we vaak krijgen
          </h2>
        </div>

        <Accordion type="single" collapsible className="mt-12 w-full">
          {items.map((it, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              className="border border-oc-border rounded-oc mb-3 px-6 data-[state=open]:bg-oc-subtle"
            >
              <AccordionTrigger className="font-display font-semibold text-oc-primary text-[18px] py-5 hover:no-underline">
                {it.q}
              </AccordionTrigger>
              <AccordionContent className="text-oc-textSecondary text-[16px] leading-relaxed pb-6">
                {it.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>

        <Link to="/faq" className="inline-flex items-center mt-8 text-oc-secondary hover:text-oc-primary font-semibold text-[15px] transition-colors">
          Bekijk alle veelgestelde vragen
          <ArrowRight className="w-4 h-4 ml-2" />
        </Link>
      </div>
    </section>
  );
}
